import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { Dialog as PrimeDialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import { errorService } from '../../services/ErrorService';
import { showErrorToast, showSuccessToast } from '../../utils/ToastUtils';
import { Menu } from 'primereact/menu';
import { Skeleton } from 'primereact/skeleton';
import QuestionImage from '../../components/QuestionImage';

import { 
    selectLoading, 
    selectTestList,
    selectQuestionList, 
    selectQuestionListCount, 
    selectPage, 
    getQuestionsAsync, 
    getQuestionsCountAsync, 
    getTestsAsync,
    deleteQuestionAsync, 
    deleteQuestionsAsync, 
    editQuestionAsync,
    editChoiceAsync, 
} from './testSlice';

const TestsView = () => {

    let emptyChoice = {
        id: null,
        option: '',
        description: '',
        isCorrect: null,
        explanation: '',
        questionId: null,
    };

    let emptyQuestion = {
        order: null,
        id: null,
        description: "",
        title: "",
        image: null,
        isCanceled: false,
        testId: null,
        moduleId: null,
        answerKeyText: "",
        test: {
          title: "",
          id: null
        },
        module: {
          id: null,
          description: "",
          weightPercentage: 0.0
        },
        choices: []
    }

    const defaultGridParameters = {offset: 0, first: 0, rows: 10, sortField: 'id', sortOrder: 1, filters: {}}
    
    const [choiceDialog, setChoiceDialog] = useState(false);

    const [deleteQuestionDialog, setDeleteQuestionDialog] = useState(false);
    
    const [deleteChoiceDialog, setDeleteChoiceDialog] = useState(false);
    const [deleteQuestionsDialog, setDeleteQuestionsDialog] = useState(false);
    const [choice, setChoice] = useState(emptyChoice);

    const [questionDialog, setQuestionDialog] = useState(false);
    const [question, setQuestion] = useState(emptyQuestion);
    const [selectedQuestions, setSelectedQuestions] = useState(null);
    const [selectionMode, setSelectionMode] = useState(false);

    const [gridParameters, setGridParameters] = useState(defaultGridParameters);

    const [dropdownValue, setDropdownValue] = useState(null);

    const [filters, setFilters] = useState({
        'id': { value: null, matchMode: FilterMatchMode.EQUALS },
        'title': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'description': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'isCanceled': { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [expandedRows, setExpandedRows] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const [imageDialog, setImageDialog] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [textDialog, setTextDialog] = useState(false);
    const [selectedText, setSelectedText] = useState({ title: '', content: '' });

    const [imageRefresh, setImageRefresh] = useState(Date.now());

    const [fileSelectedImage, setFileSelectedImage] = useState(false);
    const [fileSelectedAnswerKey, setFileSelectedAnswerKey] = useState(false);

    const dispatch = useDispatch();
    const loading = useSelector(selectLoading);
    const testList = useSelector(selectTestList);
    const questionList = useSelector(selectQuestionList);
    const questionListCount = useSelector(selectQuestionListCount);
    const offset = useSelector(selectPage);

    const menu = useRef(null);
    const [detail, setDetail] = useState({});

    const toggleMenu = (event, data) => {
        setDetail(data)
        menu.current.toggle(event);
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: false, className: 'custom-choose-btn p-button.p-button-text p-button-outlined' };

    const isOralType = (rowData) => rowData.answerType === 'IMAGE' || rowData.answerType === 'IMAGE_TEXT';
    const isTextType = (rowData) => rowData.answerType === 'TEXT' || rowData.answerType === 'IMAGE_TEXT';
    console.log('detail', detail.id);

    const toolbarItems = [
        {
            label: 'Editar',
            icon: 'pi pi-pencil',
            command: () => editQuestion(detail)
        },
        {
            label: 'Excluir',
            icon: 'pi pi-trash',
            command: () => confirmDeleteQuestion(detail)
        },
        {
            separator: true
        },
        {
            label: 'Upload de Imagem',
            template: (item) => (
                <div className="p-menuitem-link" style={{ cursor: 'pointer', background: 'white' }}>
                    <FileUpload 
                        mode="basic" 
                        accept="images/*" 
                        maxFileSize={10000000} 
                        chooseOptions={{
                            label: fileSelectedImage ? "Enviar" : "Imagem Questão",
                            icon: fileSelectedImage ? "pi pi-upload" : "pi pi-image",
                            className: fileSelectedImage ? "p-button-danger" : "p-button-outlined"
                        }}
                        uploadOptions={fileSelectedImage ? { className: "p-button-danger" } : {}}
                        target=".custom-choose-btn"
                        onSelect={() => setFileSelectedImage(true)}
                        onClear={() => setFileSelectedImage(false)}
                        onUpload={(e) => {
                            showSuccessToast(toast, 'Sucesso', 'Importação iniciada');
                            setImageRefresh(Date.now());
                            setFileSelectedImage(false);
                            loadDataGrid();
                        }}
                        onError={(e) => {
                            showErrorToast(toast, 'Erro', 'Falha na importação');
                            setImageRefresh(Date.now());
                            setFileSelectedImage(false);
                            loadDataGrid();
                        }}
                        onBeforeSend={(e) => {
                            e.xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem(process.env.REACT_APP_TOKEN_KEY)}`);
                            e.xhr.setRequestHeader('X-Client-Id', process.env.REACT_APP_API_X_CLIENT_ID);
                        }}
                        uploadHandler={(e) => console.log('uploadHandler', e)}
                        url={`${process.env.REACT_APP_API_URL}/questions/image/${detail.id}`}
                        className="p-menuitem-upload"
                    />
                </div>
            )
        },
        {
            label: 'Upload Gabarito Oral',
            visible: isOralType(detail),
            template: (item) => (
                isOralType(detail) && (
                    <div className="p-menuitem-link" style={{ cursor: 'pointer', background: 'white' }}>
                        <FileUpload
                            mode="basic"
                            accept="images/*"
                            maxFileSize={10000000}
                            chooseOptions={{
                                label: fileSelectedAnswerKey ? "Enviar Gabarito" : "Imagem Gabarito",
                                icon: fileSelectedAnswerKey ? "pi pi-upload" : "pi pi-image",
                                className: fileSelectedAnswerKey ? "p-button-danger" : "p-button-outlined"
                            }}
                            uploadOptions={fileSelectedAnswerKey ? { className: "p-button-danger" } : {}}
                            target=".custom-choose-btn"
                            onSelect={() => setFileSelectedAnswerKey(true)}
                            onClear={() => setFileSelectedAnswerKey(false)}
                            onUpload={(e) => {
                                showSuccessToast(toast, 'Sucesso', 'Importação iniciada');
                                setImageRefresh(Date.now());
                                setFileSelectedAnswerKey(false);
                                loadDataGrid();
                            }}
                            onError={(e) => {
                                showErrorToast(toast, 'Erro', 'Falha na importação');
                                setImageRefresh(Date.now());
                                setFileSelectedAnswerKey(false);
                                loadDataGrid();
                            }}
                            onBeforeSend={(e) => {
                                e.xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem(process.env.REACT_APP_TOKEN_KEY)}`);
                                e.xhr.setRequestHeader('X-Client-Id', process.env.REACT_APP_API_X_CLIENT_ID);
                            }}
                            url={`${process.env.REACT_APP_API_URL}/questions/image/${detail.id}?isKey=true`}
                            className="p-menuitem-upload"
                        />
                    </div>
                )
            )
        }
    ];

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                await errorService.retryOperation(async () => {
                    await Promise.all([
                        dispatch(getQuestionsCountAsync(defaultGridParameters)).unwrap(),
                        dispatch(getQuestionsAsync(defaultGridParameters)).unwrap(),
                        dispatch(getTestsAsync()).unwrap()
                    ]);
                });
            } catch (error) {
                showErrorToast(toast, 'Erro ao carregar dados', error);
            }
        };

        loadInitialData();
    }, [dispatch]);

    const initialLoadDataGrid = async () => {
        try {
            await errorService.retryOperation(async () => {
                await Promise.all([
                    dispatch(getQuestionsCountAsync(defaultGridParameters)).unwrap(),
                    dispatch(getQuestionsAsync(defaultGridParameters)).unwrap()
                ]);
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao carregar dados', error);
        }
    };

    const loadDataGrid = async () => {
        try {
            await errorService.retryOperation(async () => {
                await Promise.all([
                    dispatch(getQuestionsCountAsync({filters: gridParameters.filters})).unwrap(),
                    dispatch(getQuestionsAsync(gridParameters)).unwrap()
                ]);
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao recarregar dados', error);
        }
    };
    
    const onSort = async (event) => {
        try {
            await errorService.retryOperation(async () => {
                const filters = dropdownValue ? {
                    testId: { 
                        constraints: [{ value: dropdownValue.id, matchMode: FilterMatchMode.EQUALS }], 
                        operator: 'and' 
                    }
                } : gridParameters.filters;

                const sortParams = {
                    ...gridParameters,
                    sortField: event.sortField,
                    sortOrder: event.sortOrder,
            filters
        };
                setGridParameters(sortParams);
                await Promise.all([
                    dispatch(getQuestionsAsync(sortParams)).unwrap(),
                    dispatch(getQuestionsCountAsync({filters: sortParams.filters})).unwrap()
                ]);
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao ordenar questões', error);
        }
    };

    const onFilter = async (event) => {
        try {
            await errorService.retryOperation(async () => {
                const filters = dropdownValue ? {
                    testId: { 
                        constraints: [{ value: dropdownValue.id, matchMode: FilterMatchMode.EQUALS }], 
                        operator: 'and' 
                    },
                    ...event.filters
                } : event.filters;

                const filterParams = {
                    ...gridParameters,
                    page: 0,
            first: 0,
            filters
        };
                setGridParameters(filterParams);
                await Promise.all([
                    dispatch(getQuestionsAsync(filterParams)).unwrap(),
                    dispatch(getQuestionsCountAsync({filters: filterParams.filters})).unwrap()
                ]);
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao filtrar questões', error);
        }
    };
    
    const onPage = async (event) => {
        try {
            await errorService.retryOperation(async () => {
                const filters = dropdownValue ? {
                    testId: { 
                        constraints: [{ value: dropdownValue.id, matchMode: FilterMatchMode.EQUALS }], 
                        operator: 'and' 
                    }
                } : gridParameters.filters;

                const pageParams = {
                    ...gridParameters,
                    ...event,
            filters
        };
                setGridParameters(pageParams);
                await dispatch(getQuestionsAsync(pageParams)).unwrap();
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao mudar página', error);
        }
    };

    const openNew = () => {
        setChoice(emptyChoice);
        setSubmitted(false);
        setChoiceDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setChoiceDialog(false);
    }

    const hideQuestionDialog = () => {
        setSubmitted(false);
        setQuestionDialog(false);
    }

    const hideDeleteChoiceDialog = () => {
        setDeleteChoiceDialog(false);
    }

    const hideDeleteQuestionDialog = () => {
        setDeleteQuestionDialog(false);
    }

    const hideDeleteQuestionsDialog = () => {
        setDeleteQuestionsDialog(false);
        setSelectionMode(false);
        setSelectedQuestions(null);
    }

    const saveChoice = async () => {
        setSubmitted(true);
        try {
            await errorService.retryOperation(async () => {
                await dispatch(editChoiceAsync({choice, gridParameters})).unwrap();
                showSuccessToast(toast, 'Sucesso', 'Alternativa da questão atualizada');
        setChoiceDialog(false);
                setChoice(emptyChoice);
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao salvar alternativa', error);
    }
    };

    const saveQuestion = async () => {
        setSubmitted(true);
        try {
            await errorService.retryOperation(async () => {
                await dispatch(editQuestionAsync({question, gridParameters})).unwrap();
                showSuccessToast(toast, 'Sucesso', 'Questão atualizada');
        setQuestionDialog(false);
                setQuestion(emptyQuestion);
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao salvar questão', error);
    }
    };

    const editChoice = (choice) => {
        setChoice({ ...choice });
        setChoiceDialog(true);
    }

    const editQuestion = (question) => {
        setQuestion({ ...question });
        setQuestionDialog(true);
    }

    const confirmDeleteChoice = (choice) => {
        setChoice(choice);
        setDeleteChoiceDialog(true);
    }

    const confirmDeleteQuestion = (question) => {
        setQuestion(question);
        setDeleteQuestionDialog(true);
    }

    const deleteChoice = () => {
        setDeleteChoiceDialog(false);
        setChoice(emptyChoice);
        showSuccessToast(toast, 'Sucesso', 'Alternativa excluída');
    }

    const deleteQuestion = async () => {
        try {
            await errorService.retryOperation(async () => {
                const deleteParams = {
                    ...gridParameters,
                    offset: 0,
                    first: 0
                };
                await dispatch(deleteQuestionAsync({id: question.id, gridParameters: deleteParams})).unwrap();
                showSuccessToast(toast, 'Sucesso', 'Questão excluída');
        setDeleteQuestionDialog(false);
        setQuestion(emptyQuestion);
                setGridParameters(deleteParams);
                await loadDataGrid();
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao excluir questão', error);
        }
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const confirmDeleteSelected = () => {
        setDeleteQuestionsDialog(true);
    }

    const deleteSelectedQuestions = async () => {
        try {
            await errorService.retryOperation(async () => {
                const deleteParams = {
                    ...gridParameters,
                    offset: 0,
                    first: 0
                };
                await dispatch(deleteQuestionsAsync({
                    ids: selectedQuestions.map(question => question.id),
                    gridParameters: deleteParams
                })).unwrap();
                showSuccessToast(toast, 'Sucesso', 'Questões excluídas');
        setDeleteQuestionsDialog(false);
        setSelectedQuestions(null);
                setGridParameters(deleteParams);
                await loadDataGrid();
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao excluir questões', error);
        }
    };

    const onIsCanceledChange = (e) => {
        let _question = { ...question };
        _question['isCanceled'] = !e.value;
        setQuestion(_question);
    }

    const onIsCorrectChange = (e) => {
        let _choice = { ...choice };
        _choice['isCorrect'] = !e.value;
        setChoice(_choice);
    }

    const onInputChangeQuestion = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _question = { ...question };
        _question[`${name}`] = val;
        setQuestion(_question);
    }

    const onInputChangeChoice = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _choice = { ...choice };
        _choice[`${name}`] = val;

        setChoice(_choice);
    }

    const onDropdownChangeTest = async (e) => {
        try {
            await errorService.retryOperation(async () => {
                const selectedTest = e.value;
                setDropdownValue(selectedTest);
                
                const filters = selectedTest ? {
                    testId: { 
                        constraints: [{ value: selectedTest.id, matchMode: FilterMatchMode.EQUALS }], 
                        operator: 'and' 
                    }
                } : {};

                const params = { 
                    ...gridParameters, 
                    filters,
                    offset: 0, 
                    first: 0 
                };
                setGridParameters(params);
                await Promise.all([
                    dispatch(getQuestionsAsync(params)).unwrap(),
                    dispatch(getQuestionsCountAsync({filters})).unwrap()
                ]);
            });
        } catch (error) {
            showErrorToast(toast, 'Erro ao filtrar por teste', error);
        }
    };

    // Mesmo padrão dos filtros de Prova das telas de Desempenho
    // (QuestionPerformanceChart.js) — label pequeno acima, showClear, busca
    // no próprio dropdown.
    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-column gap-1">
                <label htmlFor="tests-prova-filter" className="text-xs text-color-secondary">Prova</label>
                <Dropdown
                    inputId="tests-prova-filter"
                    value={dropdownValue}
                    onChange={(e) => onDropdownChangeTest(e)}
                    options={Array.isArray(testList) ? testList : []}
                    optionLabel="title"
                    placeholder="Filtrar por prova"
                    showClear
                    filter
                    className="w-full md:w-15rem"
                    panelStyle={{ width: '20rem' }}
                />
            </div>
        )
    }

    // Mesma disposição da tela PAGES > Crud / Gestão de usuários: filtro à
    // esquerda, ações à direita, tudo no header da própria DataTable.
    const gridHeaderTemplate = () => (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3">
            {rightToolbarTemplate()}
            {leftToolbarTemplate()}
        </div>
    );

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                {!selectionMode ? (
                    <Button 
                        label="Excluir Múltiplos" 
                        icon="pi pi-trash" 
                        className="mr-2 p-button-danger" 
                        onClick={() => setSelectionMode(true)} 
                    />
                ) : (
                    <div>
                        <Button 
                            label="Confirmar" 
                            icon="pi pi-check" 
                            className="mr-2 p-button-success" 
                            onClick={confirmDeleteSelected} 
                            disabled={!selectedQuestions || !selectedQuestions.length} 
                        />
                        <Button 
                            label="Cancelar" 
                            icon="pi pi-times" 
                            className="p-button-secondary" 
                            onClick={() => {
                                setSelectionMode(false);
                                setSelectedQuestions(null);
                            }} 
                        />
                    </div>
                )}
            </React.Fragment>
        )
    }

    const emptyTemplate = () => {
        return (
            <div className="p-d-flex p-ai-center p-dir-col">
                <i className="pi pi-image p-mt-3 p-p-5" style={{'fontSize': '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)'}}></i>
                <span style={{'fontSize': '1.2em', color: 'var(--text-color-secondary)'}} className="p-my-5">Drag and Drop Image Here</span>
            </div>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return <>
            <Menu ref={menu} model={toolbarItems} popup />
            <Button type="button" label="Ações" icon="pi pi-angle-down" onClick={(event) => toggleMenu(event, rowData)} style={{ width: 'auto' }} />
        </>;
    }

    const isCorrectBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Gabarito</span>
                {rowData.isCorrect ? (
                    <span style={{ color: 'green', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                        <i className="pi pi-check-circle" style={{ marginRight: 4 }}></i> Correta
                    </span>
                ) : (
                    <span style={{ color: '#888' }}>Incorreta</span>
                )}
            </>
        )
    }

    const actionBodyTemplateChoice = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-info p-button-sm" tooltip="Editar alternativa" tooltipOptions={{position:'top'}} onClick={() => editChoice(rowData)} />
            </div>
        );
    }

    const explanationBodyTemplate = (rowData) => {
        const maxLen = 30;
        const text = rowData.explanation || '';
        if (text.length > maxLen) {
            return (
                <span title={text} style={{ cursor: 'pointer' }}>{text.substring(0, maxLen)}...</span>
            );
        }
        return <span>{text}</span>;
    }

    const rowExpansionTemplate = (data) => {
        if (!data.choices || data.choices.length === 0) {
            return null;
        }
        return (
            <div className="orders-subtable">
                <h5>{data.title} - Alternativas:</h5>
                <DataTable value={data.choices} responsiveLayout="scroll" rowClassName={alt => alt.isCorrect ? 'alt-correct' : ''}>
                    <Column field="option" header="Alternativa" sortable></Column>
                    <Column field="description" header="Descrição" sortable></Column>
                    <Column field="isCorrect" header="Gabarito" sortable body={isCorrectBodyTemplate}></Column>
                    <Column field="explanation" header="Explicação" body={explanationBodyTemplate} sortable></Column>
                    <Column body={actionBodyTemplateChoice} style={{ width: '8%', minWidth: '5rem' }}></Column>
                </DataTable>
            </div>
        );
    }

    const idBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">ID</span>
                {rowData.id}
            </>
        );
    }

    const isCanceledBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Anulada?</span>
                {rowData.isCanceled ? 'Sim' : 'Não'}
            </>
        );
    }

    const testBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Prova</span>
                {rowData.test.title}
            </>
        );
    }

    const titleBodyTemplate = (rowData) => {
        const maxLength = 50;
        const text = rowData.title || '';
        const displayText = text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
        
        return (
            <>
                <span className="p-column-title">Título</span>
                <span 
                    className="cursor-pointer text-primary" 
                    onClick={() => {
                        setSelectedText({ title: 'Título da Questão', content: text });
                        setTextDialog(true);
                    }}
                    style={{ textDecoration: 'underline' }}
                >
                    {displayText}
                </span>
            </>
        );
    }

    const descriptionBodyTemplate = (rowData) => {
        const maxLength = 100;
        const text = rowData.description || '';
        const displayText = text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
        
        return (
            <>
                <span className="p-column-title">Descrição</span>
                <span 
                    className="cursor-pointer text-primary" 
                    onClick={() => {
                        setSelectedText({ title: 'Descrição da Questão', content: text });
                        setTextDialog(true);
                    }}
                    style={{ textDecoration: 'underline' }}
                >
                    {displayText}
                </span>
            </>
        );
    }

    const imageBodyTemplate = (rowData) => {
        if (!rowData.image) return null;
        return (
            <QuestionImage
                questionId={rowData.id}
                type="main"
                width={60}
                refresh={imageRefresh}
                onClick={(src) => { setSelectedImage(src); setImageDialog(true); }}
            />
        );
    }

    const answerKeyImageBodyTemplate = (rowData) => {
        if (rowData.questionClassification !== 'ORAL_TEST' || !rowData.answerKeyImage) return null;
        return (
            <QuestionImage
                questionId={rowData.id}
                type="key"
                width={60}
                refresh={imageRefresh}
                onClick={(src) => { setSelectedImage(src); setImageDialog(true); }}
            />
        );
    };

    const choiceDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={saveChoice} />
        </>
    );

    const questionDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideQuestionDialog} />
            <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={saveQuestion} />
        </>
    );

    const deleteChoiceDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteChoiceDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteChoice} />
        </>
    );

    const deleteQuestionDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteQuestionDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteQuestion} />
        </>
    );

    const deleteQuestionsDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteQuestionsDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedQuestions} />
        </>
    );

    const hasOralTest = questionList.some(q => q.questionClassification === 'ORAL_TEST');

    return (
      <>
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <div className="flex justify-content-between align-items-center mb-3">
                        <h5 className="m-0">Gestão de provas</h5>
                        <Button
                            icon="pi pi-refresh"
                            rounded
                            text
                            onClick={loadDataGrid}
                            disabled={loading}
                        />
                    </div>
                    <DataTable ref={dt} value={loading ? Array.from({ length: gridParameters.rows }, (_, i) => ({ id: `skeleton-${i}` })) : questionList} selection={selectionMode ? selectedQuestions : undefined} onSelectionChange={(e) => setSelectedQuestions(e.value)}
                        header={gridHeaderTemplate()}
                        dataKey="id"
                        paginator
                        sortField={gridParameters.sortField}
                        sortOrder={gridParameters.sortOrder}
                        rows={gridParameters.rows}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Exibindo de {first} à {last} de {totalRecords} questões"
                        globalFilter={globalFilter}
                        emptyMessage="Sem resultados."
                        responsiveLayout="scroll"
                        rowExpansionTemplate={rowExpansionTemplate}
                        expandedRows={expandedRows}
                        onRowToggle={(e) => setExpandedRows(e.data)}
                        rowExpansionDisabled={rowData => !rowData.choices || rowData.choices.length === 0}
                        totalRecords={questionListCount}
                        lazy={true}
                        first={gridParameters.first}
                        onSort={(e) => onSort(e)}
                        onFilter={(e) => onFilter(e)}
                        onPage={(e) => onPage(e)}

                        >
                        <Column expander style={{ width: '3rem' }} rowExpansionDisabled={rowData => !rowData.choices || rowData.choices.length === 0} body={loading ? () => <Skeleton /> : undefined} />
                        {selectionMode && <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />}
                        <Column field="id" header="ID" sortable={!loading} body={loading ? () => <Skeleton /> : idBodyTemplate} headerStyle={{ width: '5rem' }}></Column>
                        <Column field="order" header="Questão" filterPlaceholder="Buscar por título" showAddButton={false} showFilterOperator={false} filterMatchMode={FilterMatchMode.CONTAINS} filterMatchModeOptions={[FilterMatchMode.CONTAINS]} sortable={!loading} body={loading ? () => <Skeleton /> : titleBodyTemplate} headerStyle={{ width: '25%' }}></Column>
                        <Column field="description" header="Enunciado" sortable={!loading} body={loading ? () => <Skeleton /> : descriptionBodyTemplate} headerStyle={{ width: '35%' }}></Column>
                        <Column field="isCanceled" header="Anulada?" sortable={!loading} body={loading ? () => <Skeleton /> : isCanceledBodyTemplate} headerStyle={{ width: '7rem' }}></Column>
                        <Column header="Imagem" body={loading ? () => <Skeleton /> : imageBodyTemplate} headerStyle={{ width: '8rem' }} />
                        {hasOralTest && (
                            <Column header="Gabarito Oral" body={loading ? () => <Skeleton /> : answerKeyImageBodyTemplate} headerStyle={{ width: '8rem' }} />
                        )}
                        <Column body={loading ? () => <Skeleton /> : actionBodyTemplate} headerStyle={{ width: '8rem' }}></Column>
                    </DataTable>

                    <Dialog 
                        visible={questionDialog} 
                        style={{ width: '80vw', maxWidth: '800px' }} 
                        header="Editar questão" 
                        modal 
                        className="p-fluid" 
                        footer={questionDialogFooter} 
                        onHide={hideQuestionDialog}
                        maximizable
                        blockScroll={false}
                    >
                        <div className="grid">
                            {/* Imagens */}
                            <div className="col-12">
                                <div className="flex gap-3 justify-content-center mb-3">
                                    {question.image && (
                                        <div className="text-center">
                                            <QuestionImage
                                                questionId={question.id}
                                                type="main"
                                                width={80}
                                                refresh={imageRefresh}
                                                style={{ height: 80, objectFit: 'cover' }}
                                                onClick={(src) => { setSelectedImage(src); setImageDialog(true); }}
                                            />
                                            <p className="text-xs text-600 mt-1">Imagem da Questão</p>
                                        </div>
                                    )}
                                    {question.questionClassification === 'ORAL_TEST' && question.answerKeyImage && (
                                        <div className="text-center">
                                            <QuestionImage
                                                questionId={question.id}
                                                type="key"
                                                width={80}
                                                refresh={imageRefresh}
                                                style={{ height: 80, objectFit: 'cover' }}
                                                onClick={(src) => { setSelectedImage(src); setImageDialog(true); }}
                                            />
                                            <p className="text-xs text-600 mt-1">Gabarito Oral</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Título e Tipo de Resposta */}
                            <div className="col-12">
                                <h5 className="mb-2">{question.title}</h5>
                                {question.questionClassification === 'ORAL_TEST' && (
                                    <div className="mb-3">
                                        <span className="inline-flex align-items-center px-2 py-1 border-round text-sm font-medium" 
                                              style={{ 
                                                  backgroundColor: question.answerType === 'TEXT' ? '#e3f2fd' : 
                                                                  question.answerType === 'IMAGE' ? '#f3e5f5' : '#e8f5e8',
                                                  color: question.answerType === 'TEXT' ? '#1976d2' : 
                                                         question.answerType === 'IMAGE' ? '#7b1fa2' : '#388e3c',
                                                  border: `1px solid ${question.answerType === 'TEXT' ? '#bbdefb' : 
                                                                      question.answerType === 'IMAGE' ? '#ce93d8' : '#a5d6a7'}`
                                              }}>
                                            <i className={`pi ${question.answerType === 'TEXT' ? 'pi-file-text' : 
                                                                  question.answerType === 'IMAGE' ? 'pi-image' : 'pi-images'} mr-2`}></i>
                                            Tipo de Resposta: {
                                                question.answerType === 'TEXT' ? 'Texto' :
                                                question.answerType === 'IMAGE' ? 'Imagem' :
                                                question.answerType === 'IMAGE_TEXT' ? 'Imagem + Texto' :
                                                question.answerType || 'Não definido'
                                            }
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Enunciado */}
                            <div className="col-12">
                                <div className="field">
                                    <label htmlFor="description">Enunciado</label>
                                    <InputTextarea 
                                        id="description" 
                                        value={question.description} 
                                        onChange={(e) => onInputChangeQuestion(e, 'description')} 
                                        required 
                                        rows={4} 
                                        cols={20} 
                                    />
                                </div>
                            </div>

                            {/* Gabarito Textual */}
                            {isTextType(question) && (
                                <div className="col-12">
                                    <div className="field">
                                        <label htmlFor="answerKeyText">Gabarito</label>
                                        <InputTextarea 
                                            id="answerKeyText" 
                                            value={question.answerKeyText || ''} 
                                            onChange={(e) => onInputChangeQuestion(e, 'answerKeyText')} 
                                            rows={3} 
                                            cols={20} 
                                            placeholder="Digite o gabarito da questão"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Questão Anulada */}
                            <div className="col-12">
                                <div className="field">
                                    <label className="mb-3">Questão anulada?</label>
                                    <div className="flex align-items-center">
                                        <Checkbox 
                                            inputId="isCanceled" 
                                            name="isCanceled" 
                                            value={question.isCanceled} 
                                            onChange={onIsCanceledChange} 
                                            checked={question.isCanceled == true} 
                                        />
                                        <label htmlFor="isCanceled" className="ml-2">
                                            {question.isCanceled ? 'Sim' : 'Não'}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </Dialog>

                    <Dialog visible={deleteQuestionDialog} style={{ width: '450px' }} header="Confirmar exclusão" modal footer={deleteQuestionDialogFooter} onHide={hideDeleteQuestionDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {choice && <span>Você deseja realmente excluir: <b>{question.title}</b>?</span>}
                        </div>
                    </Dialog>

                    <Dialog visible={choiceDialog} style={{ width: '450px' }} header="Editar alternativa" modal className="p-fluid" footer={choiceDialogFooter} onHide={hideDialog}>
                        <h5>Alternativa {choice.option}</h5>

                        <div className="field">
                            <label htmlFor="description">Descrição</label>
                            <InputTextarea id="description" value={choice.description} onChange={(e) => onInputChangeChoice(e, 'description')} required rows={3} cols={20} />
                        </div>

                        <div className="field">
                            <label htmlFor="explanation">Explicação</label>
                            <InputTextarea id="explanation" value={choice.explanation} onChange={(e) => onInputChangeChoice(e, 'explanation')} required rows={3} cols={20} />
                        </div>

                        <div className="field">
                            <label className="mb-3">Alternativa correta?</label>
                            <div className="formgrid grid">
                                <div className="field-radiobutton col-6">
                                    <Checkbox inputId="isCorrect" name="isCorrect" value={choice.isCorrect} onChange={onIsCorrectChange} checked={choice.isCorrect == true} />
                                    <label htmlFor="isCorrect">{choice.isCorrect ? 'Sim' : 'Não'}</label>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog visible={deleteChoiceDialog} style={{ width: '450px' }} header="Confirmar exclusão" modal footer={deleteChoiceDialogFooter} onHide={hideDeleteChoiceDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {choice && <span>Você deseja realmente excluir a alternativa: <b>{choice.option}</b>?</span>}
                        </div>
                    </Dialog>

                    <Dialog visible={deleteQuestionsDialog} style={{ width: '450px' }} header="Confirmar exclusão" modal footer={deleteQuestionsDialogFooter} onHide={hideDeleteQuestionsDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {<span>Você tem certeza que deseja excluir as questões selecionadas?</span>}
                        </div>
                    </Dialog>

                    <PrimeDialog header="Visualizar Imagem" visible={imageDialog} style={{ width: '50vw' }} modal onHide={() => setImageDialog(false)} closable={true}>
                        {selectedImage && (
                            <img src={selectedImage} alt="Questão" style={{ width: '100%', borderRadius: '12px' }} />
                        )}
                    </PrimeDialog>

                    <Dialog 
                        visible={textDialog} 
                        style={{ width: '50vw' }} 
                        header={selectedText.title} 
                        modal 
                        onHide={() => setTextDialog(false)}
                    >
                        <div style={{ maxHeight: '60vh', overflow: 'auto', whiteSpace: 'pre-wrap', padding: '1rem' }}>
                            {selectedText.content}
                        </div>
                    </Dialog>

                    
                </div>
            </div>
        </div>
      </>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(TestsView, comparisonFn);

<style>{`
.alt-correct td {
    background: #e6ffe6 !important;
}

.p-menuitem-upload {
    width: 100% !important;
    background: white !important;
}

.p-menuitem-upload .p-button {
    display: none;
}

.p-menuitem-upload .p-fileupload-choose {
    width: 100%;
    background: transparent !important;
    border: none;
    padding: 0;
    margin: 0;
    color: #495057;
    font-weight: normal;
}

.p-menuitem-upload .p-fileupload-choose:hover,
.p-menuitem-upload .p-fileupload-choose:focus {
    background: var(--surface-200) !important;
    border: none !important;
    box-shadow: none !important;
}

.p-menuitem-upload .p-fileupload-choose:not(.p-disabled):hover {
    background: var(--surface-200) !important;
    color: var(--text-color);
}

.p-menuitem-content {
    display: flex;
    align-items: center;
    padding: 0.75rem 1.25rem;
    width: 100%;
    background: white;
}

.p-menuitem-icon {
    margin-right: 0.5rem;
}

.p-menuitem-text {
    color: #495057;
}

.p-menuitem-link:hover {
    background: var(--surface-200) !important;
}

/* Estilos para o modal de edição de questão */
.p-dialog .p-dialog-content {
    max-height: 80vh;
    overflow-y: auto;
}

.p-dialog .p-dialog-content::-webkit-scrollbar {
    width: 6px;
}

.p-dialog .p-dialog-content::-webkit-scrollbar-track {
    background: var(--surface-100);
    border-radius: 3px;
}

.p-dialog .p-dialog-content::-webkit-scrollbar-thumb {
    background: var(--surface-300);
    border-radius: 3px;
}

.p-dialog .p-dialog-content::-webkit-scrollbar-thumb:hover {
    background: var(--surface-400);
}

/* Melhor espaçamento entre campos */
.field {
    margin-bottom: 1rem;
}

.field label {
    font-weight: 600;
    margin-bottom: 0.5rem;
    display: block;
}

/* Estilos para thumbnails de imagem no modal */
.cursor-pointer {
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cursor-pointer:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.flex {
    display: flex;
}

.gap-3 {
    gap: 1rem;
}

.justify-content-center {
    justify-content: center;
}

.text-xs {
    font-size: 0.75rem;
}

.text-600 {
    color: #6b7280;
}

/* Estilos para badge do tipo de resposta */
.inline-flex {
    display: inline-flex;
}

.align-items-center {
    align-items: center;
}

.px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

.border-round {
    border-radius: 0.375rem;
}

.text-sm {
    font-size: 0.875rem;
}

.font-medium {
    font-weight: 500;
}

.mr-2 {
    margin-right: 0.5rem;
}
`}</style>